import { useTranslation } from "react-i18next";
import { Text } from "@nbs/ui";

export function LoadingScreen({ label }: { label?: string }) {
  const { t } = useTranslation();
  return (
    <div className="nbs-page-state" role="status" aria-live="polite">
      <div className="nbs-spinner" aria-hidden="true" />
      <Text>{label ?? t("pages.loading")}</Text>
    </div>
  );
}
